class McTheme {
  constructor() {
		this.resizeTimer = null;
    this.container = document.querySelector('#footer .container');
		
    this.init();
  }
  
  init() {
		this.handleResize();
		this.initSwipers();
		this.bindEvents();
    
    if (window.jQuery) {
      this.initJQueryHooks(window.jQuery);
    }
  }
  
	bindEvents() {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.handleResize(), 100);
    });

    window.addEventListener('announcement:closed', () => {
      this.handleResize();
    });
  }
  
  handleResize() {
    const doc = document.documentElement;
    const windowWidth = window.innerWidth;
    const containerWidth = this.container ? (this.container.offsetWidth - 60) : windowWidth;
    const sidePadding = Math.max((windowWidth - containerWidth) / 2, 0);
    const header = document.getElementById('header');
    const headerHeight = header ? header.offsetHeight : 0;

    doc.style.setProperty('--mc-window-width', `${windowWidth}px`);
    doc.style.setProperty('--mc-side-padding', `${sidePadding}px`);
    doc.style.setProperty('--mc-header-height', `${headerHeight}px`);

    jQuery(window).trigger('resize.bg-video');
  }
  
  initSwipers() {
    document.querySelectorAll('.products-slider').forEach(block => {
			new ProductsSlider(block);
    });

    document.querySelectorAll('.gallery-block').forEach(block => {
			new GalleryBlock(block);
    });
    
    document.querySelectorAll('.history-block').forEach(block => {
			new HistoryBlock(block);
    });
  }
  
  initJQueryHooks($) {
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('.entry-content').fitVids();
  }
}

class ProductsSlider {
  constructor(block) {
    this.block = block;
    this.swiperEl = block.querySelector('.swiper');

		if (typeof Swiper === 'undefined') return;
    if (!this.swiperEl || this.swiperEl.swiper) return;

    this.init();
  }
	
  init() {
    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      centeredSlidesBounds: false,
      allowTouchMove: false,
      speed: 800,
      navigation: {
        nextEl: this.block.querySelector('.swiper-button-next'),
        prevEl: this.block.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: false,
        el: this.block.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: (index, className) => {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        }
      },
      breakpoints: {
        768: {
          spaceBetween: 0,
          centeredSlides: false,
          centeredSlidesBounds: false,
        }
      },
    });
  }
}

class GalleryBlock {
  constructor(block) {
    this.block = block;
    this.mainEl = this.block.querySelector('.gallery-block__main');
    this.thumbsEl = this.block.querySelector('.gallery-block__thumbs');
		if (!this.mainEl || !this.thumbsEl || typeof Swiper === 'undefined') return;
    
    this.init();
  }
  
  init() {
    this.swiperThumbs = new Swiper(this.thumbsEl, {
      slidesPerView: 3,
      spaceBetween: 10,
      allowTouchMove: true,
      speed: 800,
      breakpoints: {
        768: { slidesPerView: 4 }
      }
    });

    this.swiperMain = new Swiper(this.mainEl, {
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: true,
      speed: 800,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      thumbs: { swiper: this.swiperThumbs }
    });
  }
}

class HistoryBlock {
  constructor(block) {
    this.block = block;
    this.swiperEl = this.block.querySelector('.swiper');
		if (!this.swiperEl || typeof Swiper === 'undefined') return;
    
    this.init();
  }
  
  init() {
    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 15,
      allowTouchMove: true,
      speed: 800,
      mousewheel: {
        forceToAxis: false,
        releaseOnEdges: false
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      }
    });
  }
}

class FlyoutNav {
  constructor() {
    this.offcanvas = document.getElementById('flyout-nav');
    if (!this.offcanvas) return;

    this.btn = document.querySelector('#header .header__nav .toggle-nav');
    if (!this.btn) return;

    this.bindEvents();
  }

  bindEvents() {
    this.offcanvas.addEventListener('shown.bs.offcanvas', (e) => {
      this.btn.classList.add('active');
    });

    this.offcanvas.addEventListener('hidden.bs.offcanvas', (e) => {
      this.btn.classList.remove('active');
    });

    document.querySelectorAll('#flyout-nav .nav__item .toggle').forEach((el) => {
      el.addEventListener('click', (e) => {
        el.classList.toggle('active');

        const submenu = el.nextElementSibling;
        if (submenu) {
          submenu.classList.toggle('show');
        }
      });
    });
  }
}

class AnnouncementBar {
  constructor() {
    this.header = document.querySelector('#header');
    if (!this.header) return;

    this.container = this.header.querySelector('#header .announcement-bar');
    if (!this.container) return;

    if (sessionStorage.getItem('announcementClosed') === 'true') {
      this.close();
      return;
    }

    this.btn = this.container.querySelector('.close');
    if (!this.btn) return;

    this.bindEvents();
  }
  
  bindEvents() {
    this.btn.addEventListener('click', (e) => {
      this.close();
    });
  }

  close() {
    this.container.classList.add('d-none');
    sessionStorage.setItem('announcementClosed', 'true');

    requestAnimationFrame(() => {
      window.dispatchEvent(new Event('announcement:closed'));
    });
  }
}

class HeaderSearch {
  constructor() {
    this.header = document.querySelector('#header');
    if (!this.header) return;
    
    this.btn = this.header.querySelector('.link__item--search');
    this.form = this.header.querySelector('.search-form');
    this.input = this.form?.querySelector('.search-form__input');
    if (!this.btn || !this.form || !this.input) return; 

    this.isOpen = false;
    
    this.bindEvents();
  }
  
  bindEvents() {
    this.btn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggle();
    });
    
    this.form.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    document.addEventListener('click', () => {
      if (this.isOpen) {
        this.close();
      }
    });
  }

  open() {
    this.btn.classList.add('active');
    this.form.classList.add('show');
    this.isOpen = true;

    requestAnimationFrame(() => {
      this.input.focus();
    });
  }

  close() {
    this.btn.classList.remove('active');
    this.form.classList.remove('show');
    this.isOpen = false;
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }
}

class MoreContent {
  constructor() {
    this.wrapper = document.getElementById('more-content');
    this.toggleBtns = document.querySelectorAll('a[href="#more-content"]');

    if (!this.wrapper || !this.toggleBtns.length) return;

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.wrapper.addEventListener('hide.bs.collapse', () => {
      this.toggleBtns.forEach((btn) => {
        btn.textContent = 'Read more';
        btn.classList.remove('active');
      });
    });

    this.wrapper.addEventListener('show.bs.collapse', () => {
      this.toggleBtns.forEach((btn) => {
        btn.textContent = 'Read less';
        btn.classList.add('active');
      });
    });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  window.mcTheme = new McTheme();
  new FlyoutNav();
  new AnnouncementBar();
  new HeaderSearch();
  new MoreContent();
});